import React from 'react';

export default {
  svg: (
    <g>
      <polygon
        points="18.17,5.6 18.15,18.24 5.53,18.19 5.53,29.81 18.15,29.85 18.15,42.4 29.72,42.4 29.72,29.88
	42.37,29.88 42.37,18.24 29.81,18.19 29.78,5.6 "
        fillRule="evenodd"
      />
    </g>
  ),
  viewBox: '0 0 56 56'
};
